var search_target_template = require('./search_target_modal.twig');

import { Dropdown } from '../../components/Dropdown'
import { AttendeeQuestions } from "../../pages/manageattendance/AttendeeQuestions";

export class SearchTarget
{
    renderFilterDDs() {
        let specialtyDD = new Dropdown(app.format.getSortedSpecialties())
        specialtyDD
           .label('Specialty')
           .draw(this.dom.find("#target_search_specialty-dd-container"), 'code', 'short_name', 'specialty_code')
        this.dom.find('#target_search_specialty-dd-container > select').addClass("input-group-text")

        let degreeDD = new Dropdown(app.format.getSortedDegreesByAbbreviation())
        degreeDD
           .label('Degree')
           .draw(this.dom.find("#target_search_degree-dd-container"), 'degree_abbrv', 'degree_abbrv', 'degree')
        this.dom.find('#target_search_degree-dd-container > select').addClass("input-group-text")

        let statesDD = new Dropdown(app.appData.states)
        statesDD
            .label('State')
            .draw(this.dom.find("#target_search_state_dd-container"), 'alpha2', 'name', 'state')
        this.dom.find('#target_search_state_dd-container > select').addClass("input-group-text")

    }

    setRequired() {
      const fields = [
        { field: "firstname", fieldId: "#target_search_firstname" },
        { field: "lastname", fieldId: "#target_search_lastname" },
        { field: "city", fieldId: "#target_search_city" },
        { field: "npi_num", fieldId: "#target_search_npi_num" },
        { field: "state", fieldId: "#state" },
        { field: "degree", fieldId: "#degree" },
        { field: "specialty", fieldId: "#specialty_code" },
      ];

      this.requiredFields.forEach((requiredField) => {
        const match = fields.find((item) => item.field === requiredField);
        if (!match) {
          return;
        }

        const element = this.dom.find(match.fieldId);
        if (!element) {
          return;
        }

        element.addClass("required is-invalid");
        element.prop("required", true);
      });
    }

    checkFieldRequired(key, isvalid) {
      const fields = [
        { field: "firstname", fieldId: "#target_search_firstname" },
        { field: "lastname", fieldId: "#target_search_lastname" },
        { field: "city", fieldId: "#target_search_city" },
        { field: "npi_num", fieldId: "#target_search_npi_num" },
        { field: "state", fieldId: "#state" },
        { field: "degree", fieldId: "#degree" },
        { field: "specialty", fieldId: "#specialty_code" },
      ];
      const match = fields.find((item) => item.field === key);
      if (!match) {
        return;
      }

      const element = this.dom.find(match.fieldId);
      if (!element) {
        return;
      }
      if (element.val() && isvalid) {
        element.removeClass("is-invalid");
      } else {
        element.addClass("is-invalid");
      }
    }

    reloadDatatable() {
        this.datatable.ajax.reload();
    }

    setFilterData() {
        this.filterData = {};
        this.dom.find("#form_filter_targets input, #form_filter_targets select").each((index ,elem) => {
            this.filterData[$(elem).attr('name').replace('target_search_', '')] = $(elem).val();
        });
        this.filterData["meeting_request"] = true;
    }

    /*
        Require minimum filter criteria to be entered before enabling the search button. By default, that will remain set to just the "lastname" input.

        - Text inputs must have at least 2 characters
        - Select inputs must have a valid option chosen
        - An empty array on ref_config.SEARCH_UNIVERSE_MINIMUM_CRITERIA means at least 1 input has search data meeting the above rules
        - The config array can otherwise contain any combination of input names as defined in the ipt_validation object below
    */
    canSearch()
    {
        let ipt_validation = {
            customer_id:    (this.dom.find('#target_search_customer_id').val() ?? '').trim().length > 1,
            firstname:      (this.dom.find('#target_search_firstname').val() ?? '').trim().length > 1,
            lastname:       (this.dom.find('#target_search_lastname').val() ?? '').trim().length > 1,
            city:           (this.dom.find('#target_search_city').val() ?? '').trim().length > 1,
            state:          !['', null].includes((this.dom.find('#state').val() ?? '')),
            degree:         !['', null].includes((this.dom.find('#degree').val() ?? '')),
            specialty:      !['', null].includes((this.dom.find('#specialty_code').val() ?? '')),
            npi_num:        this.checkNpiNumberValidation((this.dom.find('#target_search_npi_num').val() ?? '').trim())
        };

        let criteria = this.requiredFields;
        if(criteria.length > 0){
            // If any rules have been specified, make sure each of them passes their check
            let pass_count = 0;
            for(let ipt in criteria){
                let isValid = false;
                if(ipt_validation[criteria[ipt]] && ipt_validation[criteria[ipt]] === true){
                    pass_count++;
                    isValid = true;
                }
                this.checkFieldRequired(criteria[ipt], isValid);
            }

            if(pass_count == criteria.length){
                return true;
            }
        }else{
            // If no rules have been specified, make sure at least 1 input contains data to search with
            for(let key in ipt_validation){
                if(ipt_validation[key] === true){
                    return true;
                }
            }
        }

        return false;
    }

    reset() {
        let topicSources = this.dom.find("[name='sources']").val()
        this.dom.find('#form_filter_targets')[0].reset()
        this.dom.find("[name='sources']").val(topicSources)
        this.dom.find('.add_attendee_via_form_button').hide()
        this.dom.find('#target_filter button').prop('disabled', true)
        this.dom.find('.attendee-val-message').hide()
        this.dom.find('#error-message').empty().hide()
    }

    validateNpi(npi) {
        if (npi !== "") {
          npi = npi.split("");
          let checkBit = parseInt(npi.pop()),
            npiDouble = [],
            npiUnchanged = [];
          npi.reverse();

          for (let i = 0; i < npi.length; i++) {
            if (i % 2 === 0) {
              npiDouble.push(npi[i] * 2);
            }

            if (i % 2 === 1) {
              npiUnchanged.push(npi[i]);
            }
          }

          npiDouble = npiDouble.toString().replace(/,/g, "");
          npiUnchanged = npiUnchanged.toString().replace(/,/g, "");
          let total = npiUnchanged + npiDouble,
            totalSum = 0;

          for (let i = 0; i < total.length; i++) {
            totalSum += parseInt(total.charAt(i));
          }

          totalSum += 24; // Magic Number
          let final = Math.ceil(totalSum / 10) * 10;
          return final - totalSum === checkBit;
        } else {
            return true;
        } 
    }

    checkNpiValidation(errorElement, inputValue) {
        let regex = /^\d{10}$/;
        if (!regex.test(String(inputValue).toLowerCase()) && inputValue !== "") {
            errorElement.text('Invalid NPI number, please enter correct NPI.').show();
            return false;
        } else if (!this.validateNpi(inputValue)) {
            errorElement.text('Invalid NPI number, please enter correct NPI.').show();
            return false;
        } else {
            errorElement.empty().hide()
            return true;
        }
    }

    checkNpiNumberValidation(inputValue) {
      let regex = /^\d{10}$/;
      if (
        !regex.test(String(inputValue).toLowerCase()) ||
        !this.validateNpi(inputValue)
      ) {
        return false;
      } else {
        return true;
      }
    }

    updateSearchButtonState() {
      let errorElement = this.dom.find("#error-message");
      let alertElement = this.dom.find("#alert-message");
      let hasErrorText = errorElement.text().trim().length > 0;
      let canSearchNow = this.canSearch();
      let flag = hasErrorText || !canSearchNow;
      this.dom.find("#target_filter button").prop("disabled", flag);
      if (flag) {
        alertElement.show();
      } else {
        alertElement.hide();
      }
    }

    constructor(attendeeData, min_req_att) {
        let target_columns = []
        this.attendeeData = attendeeData
        this.min_req_att = min_req_att
        let requiredFields = JSON.parse(app.appData.configs.SEARCH_UNIVERSE_MINIMUM_CRITERIA ?? '["lastname"]');
        if (!Array.isArray(requiredFields) || requiredFields.length === 0) {
          requiredFields = ["lastname"];
        }
        this.requiredFields = requiredFields;

        this.dom = $(twig({ data: search_target_template }).render({
            show_cust: app.appData.layout.attendance.customer_filter,
            table_data: app.appData.layout.attendance.target_table,
            min_req_att: this.min_req_att
        }))

        for (var val in app.appData.layout.attendance.target_table) {
            target_columns.push({'data': app.appData.layout.attendance.target_table[val].data})
        }

        target_columns.push({
            'data': 'target_id',
            render : (data, type, row) => {
                if(row.can_add && !(this.attendeeData.some(data => data.target_id === row.target_id)))
                {
                    return '<button type="button" class="btn btn-sm btn-primary add-target"  data-target-id="' + row.target_id + '" data-customer-id="' + row.customer_id + '" data-address-id="' + row.address_id + '" data-address-index="' + row.address_index + '" data-name="' +  row.firstname + ' ' +  row.lastname + '" data-ship_to="' + row.ship_to + '" data-inv-deg="' + row.invalid_degree + '"data-inv-spec="' + row.invalid_specialty + '"> Add</button>';
                }
                else
                {
                    return '';
                }
            }
        })

        this.datatable = this.dom.find("#datatable_targets").DataTable({
            "processing": true,
            "serverSide": true,
            "ordering": false,
            "ajax": {
                "url": "api/attendance/searchtargets",
                "data": (d) => {
                    d.data = this.filterData;
                }
            },
            "columns": target_columns,
            "pagingType": "full_numbers",
            "width" : "100%",
            "dom": '<"row"<"col-6"l><"col-6"<"row">>><t>pri',
            "deferLoading": 1,
            "pageLength": 25,
            "scrollCollapse": true,
            "language": {
                "loadingRecords": 'Please wait while we fetch your results.',
                "emptyTable":     "No Results",
                "processing": 'Please wait while we fetch your results.'
            },
            "drawCallback": function() {
                app.convertDatatableToCard("datatable_targets");
            }
        });

        this.renderFilterDDs();
        this.setRequired();

        // Enable/Disable the search button based on some criteria
        const inputs = '#target_search_customer_id, #target_search_firstname, #target_search_lastname, #target_search_city, #state, #degree, #specialty_code';

        this.dom.find(inputs).on('keyup change', () => {
            this.updateSearchButtonState();
        });

        // Npi validations
        this.dom.find("#target_search_npi_num").on("keyup", (e) => {
          let errorElement = this.dom.find("#error-message");
          let flag =
            !this.checkNpiValidation(errorElement, e.target.value) ||
            !this.canSearch();
          this.dom.find("#target_filter button").prop("disabled", flag);
        });

        this.dom.find('#form_filter_targets').on('submit', (e) => {
            e.preventDefault()
            this.dom.find('.attendee-val-message').hide()
            this.setFilterData()
            this.reloadDatatable()
        });

        this.dom.find("#datatable_targets tbody").on('click', '.add-target', (e) => {
            let button = $(e.target);
            let targetData = {...this.datatable.row($(e.target).parents('tr')).data(), ...button.data()}
            let meetingData = {
                'project_id': $('#project_dd').val(),
                'program_type_id': $('#program_type_dd').val()
            }

            this.attendeeQuestions = new AttendeeQuestions('target', 'premeeting', {
                attendeeData: targetData,
                meetingData: meetingData,
                ismeetingrequest: true
            })

            if (this.attendeeQuestions.showDialog()) {
                this.dom.find("button.close").trigger("click")

                let attendeeQuestionsDom = this.attendeeQuestions.render().dom;

                attendeeQuestionsDom.find('#questions_ship_to').select2({
                    ajax: {
                        url: "api/attendance/searchshipto",
                        dataType: "json",
                        data: (params) => {
                            return {
                                query: params.term
                            };
                        },
                        method: "GET",
                        processResults: (data) => {
                            Object.keys(data).forEach((key) => {
                                data[key]['id'] = data[key]['ship_to'].toUpperCase();
                                data[key]['text'] = `${data[key]['ship_to']}, ${data[key]['customer_name']}, ${data[key]['line_1']}, ${data[key]['city']}, ${data[key]['state']}, ${data[key]['zip']}`;
                            });

                            return {
                                results: data
                            }
                        },
                        delay: 300
                    },
                    templateResult: (data) => {
                        if(data.id && data.text) {
                            return  data.text;
                        }
                    },
                    templateSelection: (data) => {
                        if(data.id && data.text) {
                            return  data.text;
                        }
                    },
                    minimumInputLength: 2,
                    placeholder: "Please enter a ship to # or customer name to search",
                    dropdownParent: attendeeQuestionsDom.find('.modal-body')
                });

                this.attendeeQuestions.modal.show();
            } else {
                targetData.hadMeal = 2
                app.pages.meetingrequest.dom.trigger('targetInviteClicked', targetData);
            }
            button.remove()
        });

        this.modal = new bootstrap.Modal(this.dom, {backdrop: 'static', keyboard: false, show: false});
    }
}
